import { Component, Signal, ChangeDetectionStrategy } from '@angular/core';

import { SuiDialogBase, DialogCloseReason } from '@sui/dialog';

export interface UnsavedChangesDialogData {
  title: string;
  message: string;
  isValid: Signal<boolean>;
}

export interface UnsavedChangesDialogOutput {
  reason: DialogCloseReason;
}

@Component({
  selector: 'app-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UnsavedChangesDialogComponent extends SuiDialogBase<
  UnsavedChangesDialogData,
  UnsavedChangesDialogOutput
> {
  continueEditing(): void {
    this.close({ reason: DialogCloseReason.Cancel });
  }

  saveAndClose(): void {
    this.close({ reason: DialogCloseReason.SaveAndClose });
  }

  discardChanges(): void {
    this.close({ reason: DialogCloseReason.DiscardChanges });
  }
}
